// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_h8-a";
export var fulfillmentFormRail = "_h8-9";
export var headerTitleRow = "_h8-c";
export var orderDetailsWrapper = "_h8-7";
export var orderLinkTrigger = "_h8-2";
export var paymentInformationGrid = "_h8-h";
export var paymentSummaryColumn = "_h8-i";
export var shipmentContainer = "_h8-b";
export var shipmentDetailsMainPane = "_h8-8";
export var shipmentNavigationCard = "_h8-5";
export var shipmentNavigationRail = "_h8-3";
export var shipmentNavigationRailHeader = "_h8-4";
export var shipmentSummaryFact = "_h8-e";
export var shipmentSummaryGrid = "_h8-d";
export var shipmentSummaryMetadataRow = "_h8-f";
export var shipmentSummaryTags = "_h8-g";
export var shipmentWorkspace = "_h8-0";
export var shipmentWorkspaceContent = "_h8-6";
export var shipmentWorkspaceHeader = "_h8-1";